import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { CustomgridComponent, Cell } from '../ui-components/';
import { CoreLibModule } from './core-lib.module';
import { ModalLibModule } from './modal-lib.module';
import { PaginationLibModule } from './pagination-lib.module';
import { BlueboxComponent } from '../ui-components/bluebox/bluebox.component';
import { CustomGridExtendedComponent, CellExtended } from '../ui-components/custom-grid-extended/custom-grid-extended.component';
import { AgGridModule } from 'ag-grid-angular';
import { CustomGridTableComponent } from '../ui-components/custom-grid-table';

@NgModule({
    imports: [CommonModule, CoreLibModule, ModalLibModule, PaginationLibModule, ReactiveFormsModule, AgGridModule ],
    declarations: [
        CustomgridComponent,
        Cell,
        BlueboxComponent, 
        CustomGridExtendedComponent,
        CellExtended,
        CustomGridTableComponent
    ],
    exports: [
        CustomgridComponent,
        Cell,
        BlueboxComponent,
        CustomGridExtendedComponent,
        CellExtended,
        CustomGridTableComponent
        
    ]
})
export class GridLibModule { }
